import { Header } from "../../../components/header/header";
import { useEffect, useMemo, useState } from "react";
import { PageLoader } from "../../../components/loader/pageLoader";
import { useParams } from "react-router";
import { Button } from "../../../components/button/button";
import { Spring } from "../../../components/spring/spring";
import { useOpenPage } from "../../../hooks/useOpenPage";
import { HTMLPreview } from "../../../components/htmlPreview/htmlPreview";
import { MediaSlider } from "../../../components/mediaSlider/mediaSlider";
import KnowledgeAPI from "../../../api/KnowledgeAPI";

// import styles from "knowledgeMaterialPage.module.css";

export const KnowledgeMaterialPage = () => {
    const { categoryId, materialId } = useParams();

    const [materialData, setMaterialData] = useState({
        title: "Загрузка...",
        text: "",
        images: [],
    });
    const [videos, setVideos] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!materialId) return;

        setLoading(true);
        Promise.all([
            KnowledgeAPI.fetchEmployeeEducationMaterial(materialId),
            KnowledgeAPI.fetchEmployeeEducationMaterialVideos(materialId).catch((err) => {
                console.error(err);
                return [];
            })
        ])
            .then(([material, fetchedVideos]) => {
                setMaterialData(material);
                setVideos(fetchedVideos);
            })
            .catch(console.error)
            .finally(() => setLoading(false));
    }, [materialId]);

    const media = useMemo(() => {
        const videoItems = (videos || []).map(v => ({ type: "video", src: v.src }));
        const imageItems = (materialData.images || []).map(img => ({ type: "image", src: img.src }));
        return [...videoItems, ...imageItems];
    }, [materialData.images, videos]);

    const openPage = useOpenPage();

    if (loading)
        return <PageLoader />

    return (
        <>
            <Header title={materialData.title} />


            {
                media && media.length > 0 &&
                <MediaSlider media={media} />
            }

            <HTMLPreview content={materialData.text} />

            <Spring />

            <Button
                text="Прочитано"
                onClick={openPage(`/knowledge/${categoryId}`)}
            />
        </>
    );
}